<template>
  <div class="row help-wrapper">
    <!-- <header-about /> -->
    <div id="corpo" class="col s12 m8 mensagem-about-geral">
      <div v-html="meta_privacy_text"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios' //5350746737874881475

import Loading from '@/components/Loading.vue'
import HeaderAbout from "@/components/HeaderAbout.vue"

import {formataData, converteTimestamp, converteData, converteDataHora} from '@/assets/js/form-utils.js'
import SocialService from '@/services/social-service.js'
import {CONFIG} from '@/config/config.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Cronograma',
  components: {
    loading: Loading,
    "header-about": HeaderAbout
  },
  data (){
    return {
      meta_privacy_text: ""
    }
  },
  methods: {

  },
  mounted(){
    this.meta_privacy_text = this.$store.state.meta.data.termos_privacidade.privacidade
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Privacy.vue